import { CheckboxIcon } from '@primer/octicons-react';
import { Button } from '@primer/react';
import { useGetLoggedInUser } from '@upright/ui/common/generic/hooks';
import { LoginToSuggestFixesModal } from '@upright/ui/common/generic/modals/login-to-suggest-fixes-modal';
import { useOpenContributeModal } from '@upright/ui/views/model-entity-views/company-view/context/use-open-contribute-modal';
import { useState } from 'react';
import { NetImpactLensOptions } from '../../types';

export function SuggestFixes(props: { companyId: string }) {
  // ML: For now, supports only companies. If you want to use this for other entities, you will need
  // to provide modal opening function (which depends on the data) as a prop.
  const openModal = useOpenContributeModal(props.companyId);

  const [notAvailableModalOpen, setNotAvailableModalOpen] = useState(false);
  const canSuggest = useGetLoggedInUser() !== undefined;
  return (
    <>
      <Button
        variant="invisible"
        size="small"
        sx={{ fontSize: '11px' }}
        leadingVisual={CheckboxIcon}
        onClick={
          canSuggest
            ? openModal
            : () => {
                setNotAvailableModalOpen(true);
              }
        }
      >
        Help improve this data
      </Button>
      <LoginToSuggestFixesModal modalOpen={notAvailableModalOpen} setModalOpen={setNotAvailableModalOpen} />
    </>
  );
}

export function showSuggestFixes(options: NetImpactLensOptions): boolean {
  if (options.hideSuggestFixes) return false;
  if (options.staticMode) return false;
  return true;
}
